import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import AwesomeSlider from 'react-awesome-slider';
import withAutoplay from 'react-awesome-slider/dist/autoplay';
import 'react-awesome-slider/dist/styles.css';
import 'react-awesome-slider/dist/custom-animations/cube-animation.css';
import img from '../../assets/images/img.png';
import project1 from '../../assets/images/be-the-hero.png';
import project2 from '../../assets/images/to-do-list.png';
import project3 from '../../assets/images/ecoleta.png';
import project4 from '../../assets/images/tetris.png';
import {
  Container,
  WrapCaption,
  WrapProject,
  Project,
} from './styles';

const AutoplaySlider = withAutoplay(AwesomeSlider);

export default class Projects extends Component {
  render() {
    return (
      <Container>
        <WrapCaption>
          <h1>Projects</h1>
          <img src={img} alt="" /> 
        </WrapCaption>
        <WrapProject>
          <AutoplaySlider
            play={true}
            cancelOnInteraction={false} // should stop playing on user interaction
            interval={2000}
            animation="cubeAnimation"
          >
            <Project data-src={project1} /> 
            <Project data-src={project2} />
            <Project data-src={project3} />
            <Project data-src={project4} />
          </AutoplaySlider>
        </WrapProject>
        <Link to="/projects">SEE MORE</Link>
      </Container>
    );
  }
}